module.exports = __webpack_public_path__ + "img/56.b17ded92.webp";